// Action Widget Configuration
// A single-select action widget with six fixed actions.

export type TradingScoreValue =
  | 'buy_to_add'
  | 'sell_to_reduce'
  | 'maintain'
  | 'buy_to_cover'
  | 'sell_to_short'
  | 'exit';

export interface TradingScoreOption {
  value: TradingScoreValue;
  label: string;
}

export const TRADING_SCORE_ROWS: { label: string; options: TradingScoreOption[] }[] = [
  {
    label: 'Long',
    options: [
      { value: 'buy_to_add', label: 'Buy to Add' },
      { value: 'sell_to_reduce', label: 'Sell to Reduce' },
    ],
  },
  {
    label: 'Short',
    options: [
      { value: 'buy_to_cover', label: 'Buy to Cover' },
      { value: 'sell_to_short', label: 'Sell to Short' },
    ],
  },
  {
    label: 'Other',
    options: [
      { value: 'maintain', label: 'Maintain' },
      { value: 'exit', label: 'Exit' },
    ],
  },
];

export const TRADING_SCORE_OPTIONS: TradingScoreOption[] =
  TRADING_SCORE_ROWS.flatMap((r) => r.options);

export const TRADING_SCORE_STYLES: Record<
  TradingScoreValue,
  { active: string; idle: string; badge: string }
> = {
  buy_to_add: {
    idle: 'border-success-800/30 bg-success-950/40 text-success-300 hover:bg-success-900/50 hover:border-success-700/40',
    active: 'border-success-500 bg-success-900/60 text-success-200 ring-1 ring-success-500/30 shadow-md shadow-success-500/10',
    badge: 'bg-success-500 text-white',
  },
  sell_to_reduce: {
    idle: 'border-danger-800/30 bg-danger-950/40 text-danger-300 hover:bg-danger-900/50 hover:border-danger-700/40',
    active: 'border-danger-500 bg-danger-900/60 text-danger-200 ring-1 ring-danger-500/30 shadow-md shadow-danger-500/10',
    badge: 'bg-danger-500 text-white',
  },
  maintain: {
    idle: 'border-neutral-700/50 bg-neutral-800/40 text-neutral-400 hover:bg-neutral-700/50 hover:border-neutral-600/50',
    active: 'border-neutral-500 bg-neutral-700/60 text-neutral-200 ring-1 ring-neutral-500/30 shadow-md shadow-neutral-500/10',
    badge: 'bg-neutral-500 text-white',
  },
  buy_to_cover: {
    idle: 'border-success-800/30 bg-success-950/40 text-success-300 hover:bg-success-900/50 hover:border-success-700/40',
    active: 'border-success-500 bg-success-900/60 text-success-200 ring-1 ring-success-500/30 shadow-md shadow-success-500/10',
    badge: 'bg-success-500 text-white',
  },
  sell_to_short: {
    idle: 'border-danger-800/30 bg-danger-950/40 text-danger-300 hover:bg-danger-900/50 hover:border-danger-700/40',
    active: 'border-danger-500 bg-danger-900/60 text-danger-200 ring-1 ring-danger-500/30 shadow-md shadow-danger-500/10',
    badge: 'bg-danger-500 text-white',
  },
  exit: {
    idle: 'border-neutral-700/50 bg-neutral-800/40 text-neutral-400 hover:bg-neutral-700/50 hover:border-neutral-600/50',
    active: 'border-neutral-500 bg-neutral-700/60 text-neutral-200 ring-1 ring-neutral-500/30 shadow-md shadow-neutral-500/10',
    badge: 'bg-neutral-500 text-white',
  },
};

export interface TradingScoreWidgetConfig {}

export interface TradingScoreWidgetInstanceConfig extends TradingScoreWidgetConfig {
  dataKey: string;
}

export interface TradingScoreDataContent {
  action?: TradingScoreValue;
}
